import { generateKeyBetween } from "fractional-indexing";
/**
 * Sort keys for sibling ordering in the tree. Fractional indexing means a
 * move/insert only rewrites ONE item's key — crucial for CRDT merging
 * (concurrent reorders touch different keys instead of renumbering all).
 */
export function sortKeyBetween(a, b) {
    return generateKeyBetween(a, b);
}
export function compareSortKeys(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
//# sourceMappingURL=sort.js.map